

<template>
  <div class="swiper-container" id="bannerSwiper">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, index) in bannerData"
        :key="index"
      >
        <div>
          <img :src="item.img" />
          <a href="/yygk/home" target="_blank">
            <span class="enter">进入医院概况</span>
          </a>
        </div>
      </div>
    </div>
    <div id="bannerpagination" class="pagination"></div>
  </div>
</template>
  
<script>
import service from "../../service/index";
import config from "../../config/dev";
export default {
  name: "HOMEBANNER",
  props: {},
  components: {},
  data() {
    return {
      bannerData: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let parmes = {
        isshow: 1,
        pageIndex: 1,
        pageSize: 100,
      };
      service.getBannerList(parmes, (res) => {
        res.content.map((item) => {
          item.img =
            config.url + "/file/downloadFile/" + item.img + "?isDownload=true";
        });
        this.bannerData = res.content;
        this.$nextTick(() => {
          this.mySwiper();
        });
      });
    },
    mySwiper() {
      var mySwiper = new Swiper("#bannerSwiper", {
        loop: true,
        speed: 600,
        grabCursor: true,
        parallax: true,
        autoplay: {
          delay: 3000,
          //loop无效  stopOnLastSlide: true,
        },
        pagination: {
          el: "#bannerpagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".arrow-right",
          prevEl: ".arrow-left",
        },
      });
    },
  },
  mounted() {},
  watch: {},
  destroyed() {},
};
</script>
  
<style scoped lang="scss">
.swiper-container {
  width: 100vw;
  min-height: 50px;
}
.swiper-wrapper {
  width: 100vw;
  height: 500px;
}
.swiper-slide {
  width: 100vw;
  height: 500px;
}
.swiper-slide img {
  object-fit: fill;
  width: 100vw;
}
.pagination {
  position: absolute;
  left: 0;
  text-align: center;
  bottom: 15px !important;
  width: 100%;
  z-index: 999;
  margin-bottom: 0;
}

.enter {
  position: absolute;
  bottom: 45px;
  left: calc(50% - 134px);
  padding: 10px 80px;
  background: #00479d;
  color: #fff;
  border-radius: 50px;
  box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.15);
}
@media only screen and (max-width: 420px) {
  .swiper-container {
    min-height: 180px;
  }
  .swiper-wrapper {
    height: 180px;
  }
  .swiper-slide {
    height: 180px;
  }
  .enter {
    width: 100px;
    height: 36px;
    line-height: 36px;
    bottom: 10px;
    left: auto;
    right: 10px;
    padding: 0;
    font-size: 10px;
  }
}
@media only screen and (min-width: 421px) and (max-width: 768px) {
  .swiper-wrapper {
    height: 300px;
  }
  .swiper-slide {
    height: 300px;
  }
}

@media only screen and (min-width: 1920px) {
  .swiper-wrapper {
    height: 60vh;
  }
  .swiper-slide {
    height: 60vh;
  }
}
</style>
  

   